// extracted by mini-css-extract-plugin
export var disabled = "_9-a";
export var hierarchyLinkGray = "_9-4";
export var hierarchyLinkUnderline = "_9-3";
export var hierarchyPrimary = "_9-0";
export var hierarchySecondary = "_9-1";
export var hierarchyTertiary = "_9-2";
export var pressed = "_9-6";
export var themeAction = "_9-5";
export var themeDestructive = "_9-8";
export var themeNormal = "_9-7";
export var themeSuccess = "_9-9";